// ─────────────────────────────────────────────────────────────────────────────
// Logs de diagnóstico Deep Link (Universal Links / App Links / custom scheme).
// Prefixo único para filtrar no console/logcat/Safari.
// Filtro sugerido: [DeepLink]
// ─────────────────────────────────────────────────────────────────────────────

const DL_TAG = "[DeepLink]";
const DL_STYLE_INFO = "color: #1E90FF; font-weight: bold;";
const DL_STYLE_OK = "color: #2E8B57; font-weight: bold;";
const DL_STYLE_WARN = "color: #FFA500; font-weight: bold;";
const DL_STYLE_ERROR = "color: #DC143C; font-weight: bold;";

export function formatDeepLinkError(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
}

export const dlLog = {
  info(message: string, details?: unknown): void {
    if (details !== undefined) {
      console.log(`%c${DL_TAG} ${message}`, DL_STYLE_INFO, details);
      return;
    }
    console.log(`%c${DL_TAG} ${message}`, DL_STYLE_INFO);
  },

  ok(message: string, details?: unknown): void {
    if (details !== undefined) {
      console.log(`%c${DL_TAG} ✓ ${message}`, DL_STYLE_OK, details);
      return;
    }
    console.log(`%c${DL_TAG} ✓ ${message}`, DL_STYLE_OK);
  },

  warn(message: string, details?: unknown): void {
    if (details !== undefined) {
      console.warn(`%c${DL_TAG} ⚠ ${message}`, DL_STYLE_WARN, details);
      return;
    }
    console.warn(`%c${DL_TAG} ⚠ ${message}`, DL_STYLE_WARN);
  },

  error(message: string, error?: unknown, details?: unknown): void {
    const payload = {
      erro: formatDeepLinkError(error),
      ...(details !== undefined ? { detalhes: details } : {}),
    };
    console.error(`%c${DL_TAG} ✗ ${message}`, DL_STYLE_ERROR, payload, error);
  },
};
